<template>
  <div class="bg-gray-100">
    <router-view class="mt-4 ms-2"></router-view>
  </div>
</template>
